import { createSelector } from 'reselect';
import { RootState } from 'types';
import { selectAction } from './action';
import { IEntityReducer } from 'core/reducers/entities';
import { IActionBasic } from 'types/domain/action';
import { getImageFile, getScenePreview } from '../scene/scenePreview';
import { PortraitState } from 'core/slices/player';
import { EntityTypes } from 'constants/entities';

const action = selectAction;
const entity = (state: RootState) => state.entity.present;
const portrait = (state: RootState) => state.core.player.state.portrait;

export const selectActionPreview = createSelector(
  [action, entity, portrait],
  (action: IActionBasic, entity: IEntityReducer, portrait: PortraitState) => {
    if (action && action.sceneId) {
      const sceneConfig = entity[EntityTypes.SCENE_CONFIG][action.sceneConfigId];

      if (sceneConfig && sceneConfig.imageId) {
        const imageFile = getImageFile(entity, sceneConfig.imageId);

        if (imageFile) return imageFile;
      }

      return getScenePreview(entity, action.sceneId, portrait !== PortraitState.NOT_PORTRAIT);
    }
  },
);
